import React from 'react';
import { X } from 'lucide-react';

/**
 * One toggle chip of the filter bar (card 4.1): a 28 px pill with a leading
 * icon or colour dot, the name, and the count of cards that chip alone would
 * leave (boardFilterCounts.js).
 *
 * `tone` picks the ON look: 'neutral' (raised surface + the neutral grey ring,
 * never the accent — owner rule) or 'danger' (Overdue: red tint, red count
 * badge, as in the design of record). A label chip also shows an ✕ while on,
 * so it reads as "remove this filter" like Linear's filter pills.
 */
export default function BoardFilterChip({
  on = false,
  onToggle,
  icon = null,
  dot = null,
  label,
  count = null,
  tone = 'neutral',
  removable = false,
  // A label chip's id, read by useLabelChipOverflow to measure it.
  labelId = null,
}) {
  const cls = ['board-filter-chip', on && 'board-filter-chip--on', on && `board-filter-chip--${tone}`]
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" className={cls} aria-pressed={on} onClick={onToggle} data-filter-label={labelId ?? undefined}>
      {dot ? <span className="board-filter-chip-dot" style={{ background: dot }} aria-hidden /> : icon}
      <span className="board-filter-chip-name">{label}</span>
      {count != null && (
        <span className="board-filter-chip-count">{count}</span>
      )}
      {removable && on && <X size={11} strokeWidth={2.5} aria-hidden className="board-filter-chip-x" />}
    </button>
  );
}
